/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';
import { ModulesGroupsApplicationPairingsGetPairingsPairingsResponse } from '../model/modulesGroupsApplicationPairingsGetPairingsPairingsResponse';
import { ModulesGroupsApplicationPairingsRoundTournamentCourseDto } from '../model/modulesGroupsApplicationPairingsRoundTournamentCourseDto';
import { ModulesGroupsEndpointsPairingsClearPairingsRequest } from '../model/modulesGroupsEndpointsPairingsClearPairingsRequest';
import { ModulesGroupsEndpointsPairingsCopyPairingsRequest } from '../model/modulesGroupsEndpointsPairingsCopyPairingsRequest';
import { ModulesGroupsEndpointsPairingsGeneratePairingsRequest } from '../model/modulesGroupsEndpointsPairingsGeneratePairingsRequest';
import { ModulesGroupsEndpointsPairingsPublishPairingsRequest } from '../model/modulesGroupsEndpointsPairingsPublishPairingsRequest';
import { ModulesGroupsEndpointsPairingsSavePairingSettingsRequest } from '../model/modulesGroupsEndpointsPairingsSavePairingSettingsRequest';
import { ModulesGroupsEndpointsPairingsSwapGroupsRequest } from '../model/modulesGroupsEndpointsPairingsSwapGroupsRequest';
import { ModulesGroupsEndpointsPairingsSwapPlayersRequest } from '../model/modulesGroupsEndpointsPairingsSwapPlayersRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { PairingsServiceInterface }                            from './pairings.serviceInterface';


@Injectable()
export class PairingsService implements PairingsServiceInterface {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Clears pairings or groups.
     * Clears group slots (player assignments) or all blocks/groups/slots for a course.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clearPairingsEndpoint(body?: ModulesGroupsEndpointsPairingsClearPairingsRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public clearPairingsEndpoint(body?: ModulesGroupsEndpointsPairingsClearPairingsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public clearPairingsEndpoint(body?: ModulesGroupsEndpointsPairingsClearPairingsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public clearPairingsEndpoint(body?: ModulesGroupsEndpointsPairingsClearPairingsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/pairings/clear`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Copies pairings from one course to another.
     * Copies blocks, groups, and player assignments from source to target course.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public copyPairingsEndpoint(body?: ModulesGroupsEndpointsPairingsCopyPairingsRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public copyPairingsEndpoint(body?: ModulesGroupsEndpointsPairingsCopyPairingsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public copyPairingsEndpoint(body?: ModulesGroupsEndpointsPairingsCopyPairingsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public copyPairingsEndpoint(body?: ModulesGroupsEndpointsPairingsCopyPairingsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/pairings/copy`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generates pairings for a round tournament course.
     * Creates blocks, groups, and assigns players based on configuration settings.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public generatePairingsEndpoint(body?: ModulesGroupsEndpointsPairingsGeneratePairingsRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public generatePairingsEndpoint(body?: ModulesGroupsEndpointsPairingsGeneratePairingsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public generatePairingsEndpoint(body?: ModulesGroupsEndpointsPairingsGeneratePairingsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public generatePairingsEndpoint(body?: ModulesGroupsEndpointsPairingsGeneratePairingsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/pairings/generate`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets pairings for a round tournament course.
     * Gets all blocks, groups, slots, available players, and settings for the specified course.
     * @param roundTournamentCourseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPairingsEndpoint(roundTournamentCourseId?: number, observe?: 'body', reportProgress?: boolean): Observable<ModulesGroupsApplicationPairingsGetPairingsPairingsResponse>;
    public getPairingsEndpoint(roundTournamentCourseId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesGroupsApplicationPairingsGetPairingsPairingsResponse>>;
    public getPairingsEndpoint(roundTournamentCourseId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesGroupsApplicationPairingsGetPairingsPairingsResponse>>;
    public getPairingsEndpoint(roundTournamentCourseId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (roundTournamentCourseId !== undefined && roundTournamentCourseId !== null) {
            queryParameters = queryParameters.set('roundTournamentCourseId', <any>roundTournamentCourseId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesGroupsApplicationPairingsGetPairingsPairingsResponse>('get',`${this.basePath}/pairings`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets available courses for a round.
     * Gets all active RoundTournamentCourse records for the specified round.
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRoundTournamentCoursesEndpoint(roundId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesGroupsApplicationPairingsRoundTournamentCourseDto>>;
    public getRoundTournamentCoursesEndpoint(roundId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesGroupsApplicationPairingsRoundTournamentCourseDto>>>;
    public getRoundTournamentCoursesEndpoint(roundId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesGroupsApplicationPairingsRoundTournamentCourseDto>>>;
    public getRoundTournamentCoursesEndpoint(roundId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('roundId', <any>roundId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesGroupsApplicationPairingsRoundTournamentCourseDto>>('get',`${this.basePath}/pairings/round-tournament-courses`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Publishes pairings.
     * Updates the Pairings_Last_Published timestamp and triggers notifications.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public publishPairingsEndpoint(body?: ModulesGroupsEndpointsPairingsPublishPairingsRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public publishPairingsEndpoint(body?: ModulesGroupsEndpointsPairingsPublishPairingsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public publishPairingsEndpoint(body?: ModulesGroupsEndpointsPairingsPublishPairingsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public publishPairingsEndpoint(body?: ModulesGroupsEndpointsPairingsPublishPairingsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/pairings/publish`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Saves pairing settings for a round tournament course.
     * Saves configuration settings to the RoundTournamentCourseSettingLink table. These settings are used when generating pairings.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public savePairingSettingsEndpoint(body?: ModulesGroupsEndpointsPairingsSavePairingSettingsRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public savePairingSettingsEndpoint(body?: ModulesGroupsEndpointsPairingsSavePairingSettingsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public savePairingSettingsEndpoint(body?: ModulesGroupsEndpointsPairingsSavePairingSettingsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public savePairingSettingsEndpoint(body?: ModulesGroupsEndpointsPairingsSavePairingSettingsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/pairings/settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Swaps players between two groups.
     * Swaps the player assignments across the supplied groups by slot order.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public swapGroupsEndpoint(body?: ModulesGroupsEndpointsPairingsSwapGroupsRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public swapGroupsEndpoint(body?: ModulesGroupsEndpointsPairingsSwapGroupsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public swapGroupsEndpoint(body?: ModulesGroupsEndpointsPairingsSwapGroupsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public swapGroupsEndpoint(body?: ModulesGroupsEndpointsPairingsSwapGroupsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/pairings/swap/groups`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Swaps two players between group slots.
     * Swaps the scorecards assigned to the supplied group slots.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public swapPlayersEndpoint(body?: ModulesGroupsEndpointsPairingsSwapPlayersRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public swapPlayersEndpoint(body?: ModulesGroupsEndpointsPairingsSwapPlayersRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public swapPlayersEndpoint(body?: ModulesGroupsEndpointsPairingsSwapPlayersRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public swapPlayersEndpoint(body?: ModulesGroupsEndpointsPairingsSwapPlayersRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/pairings/swap/players`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
